const httpAddr = '/api/'
const baseURL = 'www.baidu.com'
const headerNav = 0

export default {
  baseURL,
  headerNav
}



// WEBPACK FOOTER //
// ./src/api/global_variable.js